/* global WebFont */

/**
 * @callback loadWebFontCallback
 * @param {boolean} success
 */

/**
 * Abstracts webfontloader so that it's a bit more
 * developer friendly.
 *
 * @param {Object} obj
 * @param {loadWebFontCallback} fn
 * @returns {void}
 */
export function loadWebFontFromSource(obj, fn) {
  // Does not work in Storybook
  if (typeof WebFont === 'undefined') {
    return;
  }

  WebFont.load({
    active: () => fn(true),
    fontinactive: () => fn(false),
    ...obj,
  });
}

/**
 * Attempts to load the given font from the HelloSign CDN.
 *
 * @param {string} font
 * @param {loadWebFontCallback} fn
 * @returns {void}
 */
export function loadWebFontFromCDN(font, fn) {
  loadWebFontFromSource({
    custom: {
      families: [font],
      urls: [`/fonts/${font.toLowerCase().replace(/\s/g, '-')}.css`],
    },
  }, fn);
}

/**
 * Attempts to load the given font from Google Fonts.
 *
 * @param {string} font
 * @param {loadWebFontCallback} fn
 * @returns {void}
 */
export function loadWebFontFromGoogle(font, fn) {
  loadWebFontFromSource({
    google: {
      families: [font],
    },
  }, fn);
}

/**
 * Attempts to load the given using Google Fonts or the
 * HelloSign CDN as a fallback.
 *
 * @param {string} font
 * @param {loadWebFontCallback} fn
 * @returns {void}
 */
export function loadWebFont(font, fn) {
  loadWebFontFromGoogle(font, (success) => {
    if (success) {
      fn(success);
    } else {
      loadWebFontFromCDN(font, (success) => {
        fn(success);
      });
    }
  });
}
